type WithId = { id?: number };

export const remapIdsByPosition = <T extends WithId>(
  items: T[],
  sourceItems: WithId[],
  targetItems: WithId[],
): T[] => {
  const positionById = new Map(sourceItems.map(({ id }, index) => [id, index]));
  return items.map(item =>
    item.id === undefined
      ? item
      : { ...item, id: targetItems[positionById.get(item.id) ?? -1]?.id },
  );
};
